import { useOrganization } from '../contexts/OrganizationContext.js';

/**
 * Hook for checking organization context requirements
 * Useful for route guards and conditional rendering
 */
function useRequireOrganization() {
    const { organizationSelected, isInternal, isLoading, clerkOrganization, dbOrganization } = useOrganization();
    return {
        hasOrganization: organizationSelected,
        isInternal,
        isLoading,
        clerkOrganization,
        dbOrganization,
    };
}

export { useRequireOrganization };
//# sourceMappingURL=useRequireOrganization.js.map
